import _ from 'lodash';

import { validatePatientLabReading, VitalsLabsTypes } from 'common-src/models/PatientLabReading';

import { TypeOptions } from 'src/popups/LabPopup/constants';

const getIsFieldRequired = (field) =>
  ['readingDate', 'typeId', 'patientReported', 'readingValue'].includes(field);

export const extractLabResult = (labResult) =>
  _.pick(labResult, ['typeId', 'readingDate', 'readingValue', 'patientReported']);

export const getIsButtonEnabled = (labResult, labResultToEdit, errors) => {
  if (
    _.isEmpty(labResult) ||
    Object.values(errors).some((e) => e) ||
    Object.entries(labResult).some(
      ([key, value]) => getIsFieldRequired(key) && [null, ''].includes(value),
    ) ||
    _.isEqual(labResult, extractLabResult(labResultToEdit))
  )
    return false;

  return true;
};

export const getAdditionalErrors = (field, value, labResult) => {
  if (field !== 'typeId') return {};

  const lymeTestValues = [
    VitalsLabsTypes.LymeTier1.value,
    VitalsLabsTypes.LymeTier2a.value,
    VitalsLabsTypes.LymeTier2b.value,
  ];

  if (!lymeTestValues.includes(value)) return {};

  const type = TypeOptions.find((option) => option.value === value);
  const validValues = type.options.map((option) => option.value);

  return validatePatientLabReading('readingValue', labResult.readingValue, validValues);
};
